import classNames from "classnames";
import { FunctionComponent } from "react";
import { useIntl } from "react-intl";
import { LegalContent, legalPageType } from "@Types/legal";
import { isAppWebView } from "@Utils/device";
import "./style.scss";

interface Props {
  data: Array<LegalContent>;
  type: legalPageType;
}

const Legal: FunctionComponent<Props> = ({ data, type }) => {
  const intl = useIntl();

  return (
    <div
      className={classNames("Legal", {
        "Legal-appWebView": isAppWebView(),
      })}
    >
      <div className="Legal-title">{intl.formatMessage({ id: `cheerz_Legal_title__${type}` })}</div>
      {data
        .sort((a, b) => a.priority - b.priority)
        .map((data: LegalContent, index: number) => (
          <div className="Legal-content" key={index}>
            <div
              className="Legal-content-subTitle"
              dangerouslySetInnerHTML={{ __html: data.subTitle }}
            />
            <div
              className="Legal-content-description"
              dangerouslySetInnerHTML={{ __html: data.description }}
            />
          </div>
        ))}
    </div>
  );
};

export default Legal;
